var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed top-0 h-16 w-full flex justify-center items-center bg-red-500 text-white z-50"},[_vm._v(" Z důvodu neaktivity prosím obnovte stránku ")])}
var staticRenderFns = []

export { render, staticRenderFns }